var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showNormalError)?_c('error-view'):(_vm.page)?_c('cms-page',{attrs:{"content":_vm.page}}):(_vm.loading)?_c('v-progress-circular',{attrs:{"size":50,"color":"grey-darken-4","indeterminate":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }